import { Component, OnInit,ViewEncapsulation, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GlobalService } from '../../../global.service';
import { Service } from '../../../services';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
@Component({
  selector: 'app-terms-netflix',
  templateUrl: './terms-netflix.component.html',
  styleUrls: ['./terms-netflix.component.sass']
})
export class TermsNetflixComponent implements OnInit {

  constructor(private loadingScreenService :LoadingScreenService,private services: Service,private global:GlobalService,public matDialogRef:MatDialogRef<TermsNetflixComponent>,@Inject(MAT_DIALOG_DATA) public data: any, private router:Router) { }

  ngOnInit() {
  }
  public close(){
    if(this.global.validateSession()===true){
      this.matDialogRef.close('cancel');
    }
  }
}
